module.exports = __webpack_public_path__ + "static/media/assessment-guide-3.31ce67e6.png";